import { Component } from '@angular/core';
import { Router, UrlSerializer, ActivatedRoute } from '@angular/router';
import { el } from 'date-fns/locale';
import { IExam, UserModel } from 'src/app/interface/dto';
import { examDefault } from 'src/app/interface/dtoDefaults';
import { EventService } from 'src/app/services/event-services/error-event.service';
import { ExamScheduleService } from 'src/app/services/exam-schedule-service';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { UserService } from 'src/app/services/user.service';
import { Util } from 'src/app/services/Util';

@Component({
  selector: 'app-create-user',
  templateUrl: './create-user.component.html',
  styleUrls: ['./create-user.component.scss']
})
export class CreateUserComponent {

  text = 'Create'
  user: UserModel = {
    id: 0,
    username: '',
    name: '',
    emailAddress: '',
    password: '',
    forceChangePassword: false,
    defaultCompany: ''
  };
  mode = "";
  window$ = window;
  disableAll = false;
  constructor(private userService: UserService, private router: Router,
    private serializer: UrlSerializer, private snackBar: SnackbarService, private examSchService: ExamScheduleService, private route: ActivatedRoute, private eventService: EventService) {
  }


  async ngOnInit() {
    const selectedUser = Array.isArray(this.userService.selectedUsers) && this.userService.selectedUsers.length > 0 ? this.userService.selectedUsers[0] : null;
    if (selectedUser) {
      this.route.paramMap.subscribe(params => {
        let userid = JSON.parse(params.get("id")) as number;
        if (selectedUser.id === userid) {
          this.text = 'Update'
          this.user = selectedUser;
        }
      });
      this.route.queryParams.subscribe(params => {
        this.mode = params['mode'] || '';
        if (this.mode == 'view-all') {
          this.disableAll = true;
          this.text = 'View'
        }
        if (this.mode == 'copy') {
          this.disableAll = false;
          this.text = 'Create'
          this.user.id = 0; // Reset ID for new exam creation
        }
      });
    }
  }

  onSubmit() {

    if (this.user.emailAddress == null || this.user.emailAddress.trim() === '') {
      this.snackBar.error("Email Address is required");
      return;
    }
    if (this.user.username == null || this.user.username.trim() === '') {
      this.snackBar.error("Username is required");
      return;
    }
    if (this.user.name == null || this.user.name.trim() === '') {
      this.snackBar.error("Name is required");
      return;
    }

    if (this.text === 'Create') {
      this.userService.createUser(this.user).then(() => {
        this.snackBar.success("User created successfully");
        this.snackBar.info("Email will be sent to the user with login instructions");
        this.userService.reloadGrid.next(true);
        this.router.navigateByUrl('/users');
      }).catch(error => {
        console.log(error);
        this.snackBar.error("Failed to create user");
      });
    } else if (this.text === 'Update') {
      this.userService.updateUser(this.user).then(() => {
        this.snackBar.success("User updated successfully");
        this.userService.reloadGrid.next(true);
        this.router.navigateByUrl('/users');
      }).catch(error => {
        console.log(error);
        this.snackBar.error("Failed to update user");
      });
    }
  }
}
